import { KTSVG } from "../_metronic/helpers";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import AddMasterForm from "../generatedForms/AddMasterForm";
import { addMaster, editMaster, getSingleMaster, getMaster , restoreProduct} from "../generatedRequest/master";
import * as Yup from "yup";
import EditMasterForm from "../generatedForms/EditMasterForm";
import FormSkeleton from "../components/Skeleton/FormSkeleton";
import RemoveProduct from "../generatedForms/RemoveProduct";
import Swal from "sweetalert2";
import DeletedChildModel from "../generatedForms/DeletedChildModel";

// import EditMasterForm from "../generatedForms/EditMasterForm";


const addValidationSchema = Yup.object().shape({
  keyword: Yup.string().required("Keyword is required"),
  selectedChildModels: Yup.array()
    .of(
      Yup.string().required("Product info item is required").min(1, "Cannot be empty")
    )
    .min(1, "At least one product info is required") 
});

const editValidationSchema = Yup.object().shape({
  
});

type TMappedProductModalProps = {
  onClose?: () => void;
  product?: any;
  isEdit?: boolean;
};

type MasterDataType = {
  _id?: string;
  productData?: any;
  removedProductData?: any;
  masterModel?: {
    id: number | null;
    displayName: string | null;
    productName: string | null;
    modelNumber: string | null;
    attributes: any[] | null;
  } | null;
  modelNumbers?: string[];
  ProductInfo?: any[];
  keyword?: string;
  brandName?: string;
  productFamily?: string;
  selectedProductGroup?: any;
  selectedChildModels?: string[];
   powerGroups?: string[];
  [key: string]: any;
} | null;

const MasterFormModal = ({ product, onClose, isEdit }: TMappedProductModalProps) => {
  const [loading, setLoading] = useState(false);
  
  const [queryParameters] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [initload, setInitload] = useState(true);
  const dispatch = useDispatch();
  
  // Helper function to create proper masterModel structure
  const createMasterModelStructure = (masterModel: any) => ({
    id: masterModel?.id || masterModel?._id || null,
    displayName: masterModel?.displayName || null,
    productName: masterModel?.productName || null,
    modelNumber: masterModel?.modelNumber || null,
    attributes: Array.isArray(masterModel?.attributes) ? masterModel.attributes : [],
  });

  // Helper function to structure master data properly
  const structureMasterData = (data: any): MasterDataType => ({

    ...data,
    masterModel: data.masterModel ? createMasterModelStructure(data.masterModel) : createMasterModelStructure(null),
    modelNumbers: Array.isArray(data.modelNumbers) ? data.modelNumbers : [],
    ProductInfo: Array.isArray(data.ProductInfo) ? data.ProductInfo : [],
    productData: Array.isArray(data.productData) ? data.productData : [],
    removedProductData: Array.isArray(data.removedProductData) ? data.removedProductData : [],
    selectedChildModels: Array.isArray(data.selectedChildModels) ? data.selectedChildModels : [],
    selectedAttributes: Array.isArray(data.selectedAttributes) ? data.selectedAttributes : [],
    powerGroups: Array.isArray(data.powerGroups) ? data.powerGroups : [],
  });

  // Initialize masterData with proper structure
  const [masterData, setMasterData] = useState<MasterDataType>({
    productData: [],
    masterModel: createMasterModelStructure(null),
    keyword: "",
    ProductInfo: [],
    brandName: "",
    productFamily: "",
    selectedProductGroup: {},
    selectedChildModels: [],
    modelNumbers: [],
    removedProductData: [],
    powerGroups: [],
  });

  const { rerender1 } = useSelector((state: RootState) => state.product);
  const navigate = useNavigate();
  const masterID = queryParameters.get("q") || "";
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  // console.log(selectedProductIds, "ids")
  // console.log(masterID, "masterID");

// const refreshPageData = async () => {
//     // console.log("User returned to page, refreshing data...");
    
//     try {
//       setLoading(true);
//       setInitload(true);

      
//       if (isEdit && masterID) {
//         // Edit mode mein fresh data fetch karo

//         const response = await getSingleMaster(masterID);
//         if (response.data.status) {
//           const data = response.data.data;
//           setMasterData(data);
          
//           // Form values ko bhi update karo
//           formik.setValues({
//             ...initialValues,
//             ...data,
//             selectedModelsList: data.modelNumbers?.map((model: string, index: number) => ({
//               id: 1000 + index,
//               name: model,
//             })) || [],
//           });
          
//           // toast.success("Data refreshed successfully!");
//         }
//       } else {
       
//         // formik.resetForm();
//         // toast.info("Form refreshed!");
//       }
      
//     } catch (error) {
//       console.error("Error refreshing data:", error);
//       toast.error("Failed to refresh data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // PAGE VISIBILITY CHANGE HANDLER
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (!document.hidden) {
//         // Page is now visible (user came back to this page)
//         refreshPageData();
//       }
//     };

//     // Focus event handler (alternative approach)
//     const handleWindowFocus = () => {
//       refreshPageData();
//     };

//     // Add event listeners
//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     window.addEventListener('focus', handleWindowFocus);

//     // Cleanup event listeners
//     return () => {
//       document.removeEventListener('visibilitychange', handleVisibilityChange);
//       window.removeEventListener('focus', handleWindowFocus);
//     };
//   }, [isEdit, masterID]);

  const initialValues = {
    // productName: "",
    keyword: "",
    // modelNumberList: [],
    // productId: "",
    // selectedModelsList: [],
    masterModel: "",
    selectedAttributes: [],
    // extractedProductInfo: [],
    productInfo: [],
    brandName : "",
    productFamily:"",
    selectedProductGroup: {},
    selectedChildModels: [],
    selectedModelsList: [],
    powerGroups: [],
  };

  // Helper function to refresh master data after operations
  const refreshMasterData = async (showSuccessMessage?: string) => {
    try {
      const response = await getSingleMaster(masterID);
      if (response.data.status) {
        const structuredData = structureMasterData(response.data.data);
        setMasterData(structuredData);
        if (showSuccessMessage) {
          toast.success(showSuccessMessage);
        }
      } else {
        toast.error("Failed to refresh master data");
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
      toast.error("Network error while refreshing master data");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: isEdit ? editValidationSchema : addValidationSchema, // Conditional validation
    onSubmit: async (values, { setSubmitting }) => {
      // console.log(values, "values");
      
      // const requestModelList = values.selectedModelsList.map((item: any) => item.name);
      try {
        const alreadyAddedIds = values.selectedChildModels.filter(id => isProductFromDatabase(id)).length;
       
        let payload = {
          selecteAttributes: values.selectedAttributes || [],
          keyword: values.keyword || "",
          masterModel : values.masterModel,
          //ProductInfo: values.productInfo,
          brandName : values.brandName,
          productFamily: values.productFamily,
          selectedProductGroup: values.selectedProductGroup,
          ProductInfo: values.selectedChildModels,
          powerGroups: values.powerGroups || []
         
        };

        let warningMessage = "";
        if (values.selectedChildModels.length > 0 && alreadyAddedIds > 0) {
            warningMessage = "You have selected " + alreadyAddedIds + " products that are already saved in the master model, so they will not be affected by the save functionality. Do you still want to update the " + (values.selectedChildModels.length - alreadyAddedIds) + " selected products for this master model?";

            Swal.fire({
              title: "Are you sure?",
              text: warningMessage,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, update it!",
              cancelButtonText: "Cancel"
          }).then(async(result) => {
              if (result.isConfirmed) {
                payload.ProductInfo = payload.ProductInfo.filter(id => !isProductFromDatabase(id));
                setLoading(true);
                setIsLoading(true);
                // console.log(payload, "payload");
                await handleSubmit(payload);
                setIsLoading(false);
                if (onClose) onClose();
              }
          });
        }else{
          setLoading(true);
          // console.log(payload, "payload");
          await handleSubmit(payload);
          setIsLoading(false);
          if (onClose) onClose();
           
        }

      } catch (error) {
        console.error("Submission error", error);
        toast.error("An error occurred during submission");
      } finally {
        setLoading(false);
        setSubmitting(false);
        setIsLoading(false);
      }
    },
  });
const editData = {
    selecteAttributes: formik.values.selectedAttributes || [],
    keyword: formik.values.keyword || "",
    masterModel: formik.values.masterModel,
    brandName: formik.values.brandName,
    productFamily: formik.values.productFamily,
    selectedProductGroup: formik.values.selectedProductGroup,
    ProductInfo: formik.values.selectedChildModels,
    powerGroups: formik.values.powerGroups || [] 
  };
  const handleSubmit = async (data: any) => {
    setLoading(true);
    try {
      const res = isEdit ? await editMaster(data, masterID) : await addMaster(data);
      if (res.data.status) {
        if(!isEdit){
          const masterId = res.data.data._id;
          navigate("/master/edit?q=" + masterId);
        } else {
          await refreshMasterData();
        }
        toast.success(isEdit ? "Master is Edited Successfully" : "Master is added Successfully");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.error("Error in handleSubmit", error);
      toast.error("Failed to add master");
    } finally {
      setLoading(false);
    }
  };

  const isProductFromDatabase = (productId: any) => {
    if (!masterData || !masterData.ProductInfo || !Array.isArray(masterData.ProductInfo)) {
        return false;
    }
    return masterData.ProductInfo.some((item: any) =>
        item.toString() === productId.toString()
    );
  };

  useEffect(() => {
    const fetchMasterData = async () => {
      setLoading(true);
      try {
        const response = await getSingleMaster(masterID);
        // console.log(response.data.data , "data")
     
        if (response.data.status) {
          const structuredData = structureMasterData(response.data.data);
          setMasterData(structuredData);
          
          // Safe mapping with proper null checks
          const selectedModelsList = Array.isArray(response.data.data.modelNumbers) 
            ? response.data.data.modelNumbers.map((model: string, index: number) => ({
                id: 1000 + index,
                name: model,
              }))
            : [];

          formik.setValues({
            ...initialValues,
            ...response.data.data,
            selectedModelsList,
            selectedChildModels: Array.isArray(response.data.data.selectedChildModels) ? response.data.data.selectedChildModels : [],
            selectedAttributes: Array.isArray(response.data.data.selectedAttributes) ? response.data.data.selectedAttributes : [],
            productInfo: Array.isArray(response.data.data.productInfo) ? response.data.data.productInfo : [],
             powerGroups: Array.isArray(response.data.data.selectedPowerValues) ? response.data.data.selectedPowerValues : [], // Add powerGroups to form values
          });
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Network Error");
        console.error("Error fetching master data:", error);
      } finally {
        setLoading(false);
        setInitload(false);
      }
    };

    if (isEdit && masterID) {
      fetchMasterData();
    } else {
      setInitload(false);
    }
  }, [isEdit, masterID]);

  const handleRestoreSuccess = async () => {
    try {
      setLoading(true);
      setInitload(true);
      await refreshMasterData("Product restored successfully");
    } finally {
      setLoading(false);
      setInitload(false);
    }
  };

  const handleSyncEdit = async (data: any) => {
    setLoading(true);
    try {
      const res = await editMaster(data, masterID);
      await refreshMasterData("updated Successfully");
    } catch (error) {
      console.error("Error in handleSubmit", error);
      toast.error("Failed to add master");
    } finally {
      setLoading(false);
    }
  };



  const handleClose = () => {
    if (isEdit) {
      navigate("/master");
    } else if (onClose) {
      onClose();
    } else {
      navigate("/master");
    }
  };
  // console.log(masterData, "masterData")
  // console.log(product, "product")

  if (loading && initload) {
    return <FormSkeleton numberOfInput={8} />;
  }

  return (
    <>
       {isLoading && (
          <div className="overlay-loader">
              <div className="loader-container">
                  <div className="spinner"></div>
                  <div className="loader-text">Searching products...</div>
              </div>
          </div>
      )}
      <div className="p-5">
        <div className="header  d-flex justify-content-start align-items-center mb-4 gap-5">
          <div
            role={"button"}
            className="btn btn-sm btn-light "
            onClick={() => navigate("/master")}
          >
            <i className="fa-solid fa-arrow-left fs-2"></i>
              
          </div>
        <h3 className="fw-bolder m-0">{isEdit ? "Edit Master Module" : "Add Master Module"}</h3>
          {/* <div className="btn btn-icon btn-sm btn-active-light-primary" onClick={handleClose}>
            <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-2x" />
          </div> */}
        </div>

        {isEdit ? (
          <EditMasterForm
            product={product}
            formik={formik}
            isEdit={!!isEdit}
            masterData={masterData}
            productData={masterData?.productData}
            onSyncEdit={handleSyncEdit}
            data={editData}
          />
       
          
        ): (
          <AddMasterForm
         
           
            formik={formik}
           
          />
        )
       }
       

        <div className="footer d-flex justify-content-end mt-4 gap-3">

          <button
            type="button"
            id="kt_password_reset_submit"
            disabled={loading || !formik.isValid || !formik.dirty}
            className="btn btn-primary"
            onClick={() => formik.handleSubmit()}
          >
            {!loading && <span className="indicator-label">{isEdit ? "Update" : "Save"}</span>}
            {loading && (
              <span className="indicator-progress" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
        </div>
        
        {isEdit && masterData?._id && (
          <>
            <hr />
            <RemoveProduct 
              masterDataId={masterData._id || ""}
              removedData={masterData?.removedProductData}
              onRestoreSuccess={handleRestoreSuccess}
            />
          </>
        )}

        {isEdit && masterData?._id && (
          <>
           
            <DeletedChildModel 
             masterDataId={masterData._id || ''}
             deletedId = {masterData?.deletedChildModelData}
             />
          </>
        )}
      </div>
    </>
  );
};

export default MasterFormModal;